// src/frontend/data/books/DarkForest/data/cap22.js

const CAP22 = {
  id: 22,
  title: "Seguridad de la Red (Network Security)",
  sections: [
    {
      heading: "¿Por qué es importante la seguridad de red?",
      text: [
        "Cada vez que firmas, envías o interactúas con una DApp, un exchange o una wallet, tu dispositivo se conecta a Internet. Esa conexión es una de las líneas de defensa más críticas.",
        "En los primeros años de Internet, los ataques de red eran mucho más comunes, especialmente mediante técnicas como 'man-in-the-middle' (MITM), DNS spoofing, Wi-Fi manipulada o HTTPS falso.",
        "Hoy, gracias a la adopción casi universal de HTTPS, TLS, VPN y certificados digitales, la seguridad de red ha mejorado significativamente. Pero el riesgo no ha desaparecido, solo ha evolucionado."
      ]
    },
    {
      heading: "HTTPS Everywhere: Protección moderna",
      text: [
        "La implementación de HTTPS Everywhere ha sido uno de los mayores avances para proteger la transmisión de datos entre usuarios y servidores.",
        "Cuando tu navegador fuerza HTTPS, cifra toda la información que viaja entre tú y el sitio web, haciendo mucho más difícil que un atacante intercepte o modifique los datos.",
        "Sin embargo, HTTPS no es invencible: si un atacante compromete el DNS, el router, o usa certificados falsos, puede redirigir el tráfico o falsificar páginas legítimas."
      ]
    },
    {
      heading: "Wi-Fi Públicas vs Datos móviles",
      list: [
        "🚫 Evita redes Wi-Fi públicas o gratuitas en aeropuertos, cafés o centros comerciales cuando uses wallets o exchanges.",
        "📶 Prefiere usar datos móviles 4G/5G para transacciones sensibles o conexión con wallets.",
        "🔐 Si necesitas usar Wi-Fi pública, conéctate solo mediante VPN confiable (ProtonVPN, NordVPN, Mullvad, etc.).",
        "📡 No conectes hardware wallets o firmes transacciones en redes desconocidas, incluso si parecen seguras."
      ]
    },
    {
      heading: "Señales de un posible ataque de red",
      text: [
        "Aunque HTTPS te protege, hay señales claras que pueden alertarte:",
        "- El navegador muestra advertencias como 'Certificado no válido', 'El sitio no es seguro', 'Tu conexión puede estar interceptada'.",
        "- La página que visitas no tiene candado SSL (🔒) o dice 'No seguro'.",
        "- El dominio luce extraño (por ejemplo: binancee.com, trezor-secure.net, metamask-info.io).",
        "- Te aparece un mensaje inesperado solicitando reingresar tus claves, seed phrase o passwords."
      ]
    },
    {
      heading: "Man-in-the-Middle (MITM): cómo funciona",
      text: [
        "Un ataque MITM ocurre cuando un atacante se posiciona entre tu dispositivo y el servidor real. Puede leer, modificar o falsificar lo que envías o recibes.",
        "Antes era más fácil usando redes Wi-Fi maliciosas o routers comprometidos. Hoy, aunque menos común, sigue ocurriendo especialmente si:",
        "- Usas redes sin cifrado (WEP o sin contraseña).",
        "- Tienes malware que manipula DNS o certificados.",
        "- Tu sistema ignora errores de certificados y los aceptas manualmente.",
        "Los ataques MITM modernos se apoyan más en ingeniería social, Cloudflare Workers maliciosos, proxies inversos, o VPN manipuladas."
      ],
      image: {
        src: "...",
        alt: "Esquema de ataque Man-in-the-Middle",
        caption: "Ejemplo de un atacante interceptando el tráfico entre el usuario y la blockchain / servidor legítimo."
      }
    },
    {
      heading: "DNS Spoofing y Domain Hijacking",
      text: [
        "Un atacante puede manipular la respuesta del DNS y redirigirte a un sitio malicioso que parece legítimo.",
        "Esto puede ocurrir incluso si escribes correctamente la dirección oficial (p. ej. metamask.io), pero terminas en meta-mask-login.io.",
        "Ejemplo histórico: El caso de MyEtherWallet en 2018, donde ataques BGP + DNS redirigieron al sitio malicioso."
      ],
      image: {
        src: "...",
        alt: "DNS Hijacking ataque",
        caption: "El atacante secuestra la consulta DNS para enviar al usuario a un sitio falso sin que se dé cuenta."
      }
    },
    {
      heading: "Buenas prácticas de seguridad de red",
      list: [
        "🛜 Usa siempre 4G/5G o una Wi-Fi privada con contraseña robusta y protocolo WPA3.",
        "🔒 Nunca ignores las advertencias de certificados SSL o HTTPS en el navegador.",
        "🌐 Instala extensión como HTTPS Everywhere o activa 'Conexión segura solamente' en tu navegador.",
        "📡 Utiliza una VPN confiable si debes conectarte a redes públicas.",
        "🔍 Revisa SIEMPRE la URL antes de introducir datos sensibles.",
        "🛠️ No realices transacciones con hardware wallets en lugares públicos usando Wi-Fi abierta."
      ]
    },
    {
      heading: "VPN: ¿cuándo usarla?",
      text: [
        "Una VPN cifra tu conexión incluso si estás en una red insegura. Sin embargo, no todas las VPN son seguras.",
        "Usa solo VPNs con buena reputación y política estricta de privacidad (no gratuitas).",
        "Evita instalar VPNs desconocidas o recomendadas por anuncios aleatorios o influencers de dudosa reputación."
      ]
    },
    {
      heading: "Conclusión general",
      text: [
        "La red es una capa silenciosa pero crucial de la seguridad digital.",
        "Aunque hoy los ataques MITM tradicionales han disminuido gracias a HTTPS, todavía existen vectores como DNS hijacking, Cloudflare Worker Misuse, VPN maliciosas o Wi-Fi manipulada.",
        "La mejor estrategia es simple: si puedes elegir entre una red potencialmente insegura y una segura, elige siempre la más segura.",
        "Y recuerda: una transacción firmada en una red comprometida puede costarte TODO."
      ]
    }
  ]
};

export default CAP22;
